import type { BlastStatus } from '../types'

const NOT_EDITABLE: BlastStatus[] = ['sent', 'approved', 'scheduled']
const NOT_DELETABLE: BlastStatus[] = ['sent', 'scheduled', 'approved']
const NOT_SUBMITTABLE: BlastStatus[] = ['sent', 'scheduled', 'approved', 'awaiting approval']

export type BlastPermissions = { destroy: boolean; approve: boolean }

const isManageable = (authorId: string | null, currentUserId: string, canDestroy: boolean) =>
  canDestroy || authorId === currentUserId

export const canEdit = (status: BlastStatus, authorId: string | null, currentUserId: string, perms: BlastPermissions) =>
  isManageable(authorId, currentUserId, perms.destroy) && !NOT_EDITABLE.includes(status)

export const canDelete = (status: BlastStatus, perms: BlastPermissions) =>
  perms.destroy && !NOT_DELETABLE.includes(status)

export const canSubmit = (
  status: BlastStatus,
  authorId: string | null,
  currentUserId: string,
  perms: BlastPermissions
) => !perms.approve && isManageable(authorId, currentUserId, perms.destroy) && !NOT_SUBMITTABLE.includes(status)

export const canApprove = (status: BlastStatus, perms: BlastPermissions) =>
  perms.approve && status === 'awaiting approval'

export const canCancel = (
  status: BlastStatus,
  authorId: string | null,
  currentUserId: string,
  perms: BlastPermissions
) => isManageable(authorId, currentUserId, perms.destroy) && status === 'scheduled'

export const unavailableReasonKey = (status: BlastStatus): string | null => {
  if (status === 'sent') return 'sent'
  if (status === 'approved') return 'approved'
  if (status === 'scheduled') return 'scheduled'
  if (status === 'awaiting approval') return 'awaiting'
  return null
}
